import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'

Vue.use(Router)
/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
**/
export const constantRouterMap = [{
		path: '/redirect',
		component: Layout,
		hidden: true,
		children: [{
			path: '/redirect/:path*',
			component: () => import('@/views/redirect/index')
		}]
	},
	{
		path: '',
		component: Layout,
		redirect: 'dashboard',
		meta: {
			role: 30
		},
		children: [{
			path: 'dashboard',
			component: () => import('@/views/dashboard/index'),
			name: 'Dashboard',
			meta: {
				title: 'dashboard',
				icon: 'dashboard',
				noCache: true,
				affix: true,
				role: 30
			}
		}]
	},
	{
		path: '/typeManage',
		component: Layout,
		redirect: 'typeManage',
		meta: {
			role: 1
		},
		children: [{
			path: 'typeManage',
			component: () => import('@/views/typeManage/index'),
			name: 'typeManage',
			meta: {
				title: '分类管理',
				icon: 'selection',
				noCache: true,
				affix: true,
				role: 1
			}
		}]
	},
	{
		path: '/implementationManage',
		component: Layout,
		redirect: 'implementationManage',
		meta: {
			role: 45
		},
		children: [{
			path: 'implementationManage',
			component: () => import('@/views/implementationManage/index'),
			name: 'implementationManage',
			meta: {
				title: '履约类型',
				icon: 'selection',
				noCache: true,
				affix: true,
				role: 45
			}
		}]
	},
	{
		path: '/channelManage',
		component: Layout,
		redirect: 'channelManage',
		meta: {
			role: 5
		},
		children: [{
			path: 'channelManage',
			component: () => import('@/views/channelManage/index'),
			name: 'channelManage',
			meta: {
				title: '渠道管理',
				icon: 'channel',
				noCache: true,
				affix: true,
				role: 5
			}
		}]
	},
	{
		path: '/groupManage',
		component: Layout,
		redirect: 'groupManage',
		meta: {
			role: 9
		},
		children: [{
			path: 'groupManage',
			component: () => import('@/views/groupManage/index'),
			name: 'groupManage',
			meta: {
				title: '商品管理',
				icon: 'goods',
				noCache: true,
				affix: true,
				role: 9
			}
		}]
	},
	{
		path: '/malfunctionManage',
		component: Layout,
		redirect: 'malfunctionManage',
		meta: {
			role: 33
		},
		children: [{
			path: 'malfunctionManage',
			component: () => import('@/views/malfunctionManage/index'),
			name: 'malfunctionManage',
			meta: {
				title: '故障管理',
				icon: 'goods',
				noCache: true,
				affix: true,
				role: 33
			}
		}]
	},
	{
		path: '/modelManage',
		component: Layout,
		redirect: 'modelManage',
		meta: {
			role: 37
		},
		children: [{
			path: 'modelManage',
			component: () => import('@/views/modelManage/index'),
			name: 'modelManage',
			meta: {
				title: '机型管理',
				icon: 'goods',
				noCache: true,
				affix: true,
				role: 37
			}
		}]
	},
	{
		path: '/brandManage',
		component: Layout,
		redirect: 'brandManage',
		meta: {
			role: 12
		},
		children: [{
			path: 'brandManage',
			component: () => import('@/views/brandManage/index'),
			name: 'brandManage',
			meta: {
				title: '品牌管理',
				icon: 'brand',
				noCache: true,
				affix: true,
				role: 12
			}
		}]
	},
	{
		path: '/versionManage',
		component: Layout,
		redirect: 'versionManage',
		meta: {
			role: 12
		},
		children: [{
			path: 'versionManage',
			component: () => import('@/views/versionManage/index'),
			name: 'versionManage',
			meta: {
				title: '型号管理',
				icon: 'goods',
				noCache: true,
				affix: true,
				role: 12
			}
		}]
	},
	{
		path: '/codeManage',
		component: Layout,
		redirect: 'codeManage',
		meta: {
			title: '激活码',
			icon: 'code',
			noCache: true,
			affix: true,
			role: 16
		},
		children: [{
				path: 'codeManage',
				component: () => import('@/views/codeManage/index'),
				name: 'codeManage',
				meta: {
					title: '激活码管理',
					icon: 'manager',
					noCache: true,
					affix: true,
					role: 50
				}
			},
			{
				path: 'codeExamine',
				component: () => import('@/views/codeManage/index'),
				name: 'codeExamine',
				props: {
					isExamine: true
				},
				meta: {
					title: '激活码审核',
					icon: 'examine',
					noCache: true,
					affix: true,
					role: 60
				}
			},
		]
	},
	{
		path: '/orderManage',
		component: Layout,
		redirect: 'orderManage',
		meta: {
			title: '订单',
			icon: 'order',
			noCache: true,
			affix: true,
			role: 25
		},
		children: [{
				path: 'orderManage',
				component: () => import('@/views/orderManage/index'),
				name: 'orderManage',
				meta: {
					title: '订单管理',
					icon: 'manager',
					noCache: true,
					affix: true,
					role: 25
				}
			},
			{
				path: 'orderExamine',
				component: () => import('@/views/orderManage/index'),
				name: 'orderExamine',
				props: {
					isExamine: true
				},
				meta: {
					title: '订单审核',
					icon: 'examine',
					noCache: true,
					affix: true,
					role: 25
				}
			},
		]
	},
	{
		path: '/exchange',
		component: Layout,
		redirect: 'exchange',
		meta: {
			title: '换机',
			icon: 'order',
			noCache: true,
			affix: true,
			role: 25
		},
		children: [{
				path: 'exchange',
				component: () => import('@/views/exchange/index'),
				name: 'exchange',
				meta: {
					title: '换机管理',
					icon: 'manager',
					noCache: true,
					affix: true,
					role: 25
				}
			},
			{
				path: 'exchangeExamine',
				component: () => import('@/views/exchange/index'),
				name: 'exchangeExamine',
				props: {
					isExamine: true
				},
				meta: {
					title: '换机审核',
					icon: 'examine',
					noCache: true,
					affix: true,
					role: 25
				}
			},
		]
	},
	{
		path: '/system',
		component: Layout,
		redirect: 'system',
		meta: {
			title: '系统管理',
			icon: 'system',
			noCache: true,
			affix: true,
			role: 31
		},
		children: [{
				path: 'log',
				component: () => import('@/views/system/log'),
				name: 'log',
				meta: {
					title: '日志',
					icon: 'log',
					noCache: true,
					affix: true,
					role: 32
				}
			},
			{
				path: 'user',
				component: () => import('@/views/system/user'),
				name: 'user',
				meta: {
					title: '用户管理',
					icon: 'user',
					noCache: true,
					affix: true,
					role: -1
				}
			},
			{
				path: 'role',
				component: () => import('@/views/system/role'),
				name: 'role',
				meta: {
					title: '角色管理',
					icon: 'user',
					noCache: true,
					affix: true,
					role: -1
				}
			},
		]
	},
	{
		path: '/login',
		component: () => import('@/views/login/index'),
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/errorPage/404'),
		hidden: true
	},
	{
		path: '/401',
		component: () => import('@/views/errorPage/401'),
		hidden: true
	},
	{
		path: '*',
		redirect: '/404',
		hidden: true
	}
]

export const routerRole = {
	30: '/',
	1: '/typeManage/typeManage',
	5: '/channelManage/channelManage',
	9: '/groupManage/groupManage',
	12: '/brandManage/brandManage',
	16: '/codeManage/codeManage',
	25: '/orderManage/orderManage',
	32: '/system/log',
	'-1': '/system/log',
}

export default new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})
export const asyncRouterMap = []